<template>
  <div>
    <div class="jumbotron">
      <div class="container marketing">
        <div class="row ">
          <div class="col-lg-8 col-xs-10"
               style="width:90%;background: #FFFFFF;padding:5%;border-radius: 5px;margin: 5%">
            <div>
              <el-row>
                <el-form ref="form" :model="backRepositoryData.form" label-width="50px" size="mini">
                  <el-form-item label="产品" prop="productId">
                    <el-select v-model.number="backRepositoryData.form.productId"
                               placeholder="请选择">
                      <el-option
                          v-for="dict in productIdOptions"
                          :key="dict.id"
                          :label="dict.productName"
                          :value="dict.id"
                      />
                    </el-select>
                  </el-form-item>
                </el-form>
              </el-row>

              <a-tabs v-model:activeKey="backRepositoryData.codeType" size="default">
                <a-tab-pane key="1" tab="直接退货"></a-tab-pane>
                <a-tab-pane key="2" tab="区间退货"></a-tab-pane>
              </a-tabs>

              <!--              码显示区-->
              <div style="min-height: 50px">
                <div style="margin: 15px" v-show="backRepositoryData.bigCodes.size>0">
                  <h5>大标</h5>
                  <ul>
                    <li v-for="item in backRepositoryData.bigCodes" :key="item">{{ item }}
                      <span style="margin-left: 25px;color: red" @click="delCode(item,'big')">删除</span>
                    </li>
                  </ul>
                </div>
                <div style="margin: 15px" v-show="backRepositoryData.midCodes.size>0">
                  <h5>中标</h5>
                  <ul>
                    <li v-for="item in backRepositoryData.midCodes" :key="item">{{ item }}
                      <span style="margin-left: 25px;color: red" @click="delCode(item,'mid')">删除</span>
                    </li>
                  </ul>
                </div>
                <div style="margin: 15px" v-show="backRepositoryData.smallCodes.size>0">
                  <h5>小标</h5>
                  <ul>
                    <li v-for="item in backRepositoryData.smallCodes" :key="item">{{ item }}
                      <span style="margin-left: 25px;color: red" @click="delCode(item,'small')">删除</span>
                    </li>
                  </ul>
                </div>
              </div>

              <el-row style="margin-top: 10px">
                <el-col :span="18">
                  <a-button type="primary" size="small" @click.native="scanCode">扫码</a-button>
                </el-col>
                <el-col :span="6">
                  <a-button size="small" type="primary" @click.native="inRepository">退货入库</a-button>
                </el-col>
              </el-row>
              <div style="margin-top: 20px;border-top: solid 1px #8b8b8b;padding-top: 10px">
              </div>
              <el-row>
                <el-col :span="12">
                  <span style="color: rgb(29, 142, 242)"><b>即将退货：</b>{{ willIn }}</span>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import {backRepository, countBackByCodes, getProductList, getStoreList} from "../api/data_bind";
import {matchCode} from "../utils/matchCode";

export default {
  data() {
    return {
      productIdOptions: [],
      fromStoreIdOptions: [],

      bigLen: [],
      midLen: [],
      smallLen: [],
      restaurants: [],
      timeout: null,
      tableData: [],
      backRepositoryData: {
        form: {},
        bigCodes: new Set(),
        midCodes: new Set(),
        smallCodes: new Set(),
        codeType: '1',
      },
      willIn: 0,
    };
  },
  watch: {
    "backRepositoryData": {
      handler: function () {
        this.$store.commit("setbackRepositoryData", this.backRepositoryData)
      }
    },
    "backRepositoryData.form.productId": {
      handler: function () {
        for (const i in this.productIdOptions) {
          if (this.productIdOptions[i].id === this.backRepositoryData.form.productId) {
            this.backRepositoryData.form.productNumber = this.productIdOptions[i].productNumber
            break
          }
        }
        this.$store.commit("setbackRepositoryData", this.backRepositoryData)
      }
    },

  },
  created() {
    this.products();
    this.stores();
    // 加载缓存
    if (this.$store.state.backRepositoryData) {
      this.backRepositoryData = this.$store.state.backRepositoryData
    }

    if (this.backRepositoryData.bigCodes.size === undefined) {
      this.backRepositoryData.bigCodes = new Set()
    }
    if (this.backRepositoryData.midCodes.size === undefined) {
      this.backRepositoryData.midCodes = new Set()
    }
    if (this.backRepositoryData.smallCodes.size === undefined) {
      this.backRepositoryData.smallCodes = new Set()
    }
    if (this.backRepositoryData.smallCodes.size +
        this.backRepositoryData.midCodes.size + this.backRepositoryData.bigCodes.size > 0) {
      this.countOutByCodesApi()
    }
    // 获取扫码数据
    this.bigLen = this.$store.state.codeLen.big
    this.midLen = this.$store.state.codeLen.mid
    this.smallLen = this.$store.state.codeLen.small
    if (this.$store.state.pre !== 'fromScan') {
      return
    }
    if (this.$store.state.code !== '') {
      this.freshCode()
    }
    this.$store.commit("setPre", '')
  },
  mounted() {
  },
  computed: {
    formItemLayout() {
      const {layout} = this.form;
      return layout === "horizontal"
          ? {
            labelCol: {span: 4},
            wrapperCol: {span: 14},
          }
          : {};
    },
    buttonItemLayout() {
      const {layout} = this.form;
      return layout === "horizontal"
          ? {
            wrapperCol: {span: 14, offset: 4},
          }
          : {};
    },
  },
  methods: {
    products() {
      getProductList({}).then((res) => {
        if (res.code == 200) {
          this.productIdOptions = res.data.list
        }
      });
    },
    stores() {
      getStoreList({}).then((res) => {
        if (res.code == 200) {
          this.fromStoreIdOptions = res.data.list
        }
      });
    },
    thId() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      const currentTimeString = `${year}${month}${day}${hours}${minutes}${seconds}`;
      this.backRepositoryData.form.outNo = "TH" + currentTimeString
    },
    delCode(code, type) {
      let delOk = false
      switch (type) {
        case 'big':
        case '大':
          delOk = this.backRepositoryData.bigCodes.delete(code)
          break
        case 'mid':
        case '中':
          delOk = this.backRepositoryData.midCodes.delete(code)
          break
        case 'small':
        case '小':
          delOk = this.backRepositoryData.smallCodes.delete(code)
          break
        default:
          return
      }
      if (delOk) {
        this.countOutByCodesApi()
      }
      this.$store.commit("setbackRepositoryData", this.backRepositoryData)
      this.$forceUpdate()
    },

    scanCode() {
      if (this.backRepositoryData.form.productId === undefined) {
        this.$message.error('请选择产品');
        return
      }

      if (this.$store.state.isDev) {
        this.$store.commit("setScanCode", "89898990")
        this.freshCode()
        return;
      } else {
        this.$router.push({
          path: '/scanCodePage'
        });
      }
    },
    freshCode() {
      const c = this.$store.state.code;
      this.recordCode(c)
      this.$forceUpdate()
      this.$store.commit("setbackRepositoryData", this.backRepositoryData)
    },
    recordCode(code) {
      const codeName = matchCode(code, this.bigLen, this.midLen, this.smallLen)
      if (codeName === '无效') {
        this.$message.error("长度不符合要求，无效码" + code)
        return
      }
      if (codeName === '大') {
        const before = this.backRepositoryData.bigCodes.size
        this.backRepositoryData.bigCodes.add(code)
        if (this.backRepositoryData.bigCodes.size === before) {
          this.$message.error("重复扫码" + code)
          return
        }

      }
      if (codeName === '中') {
        const before = this.backRepositoryData.midCodes.size
        this.backRepositoryData.midCodes.add(code)
        if (this.backRepositoryData.midCodes.size === before) {
          this.$message.error("重复扫码" + code)
          return
        }

      }
      if (codeName === '小') {
        const before = this.backRepositoryData.smallCodes.size
        this.backRepositoryData.smallCodes.add(code)
        if (this.backRepositoryData.smallCodes.size === before) {
          this.$message.error("重复扫码" + code)
          return
        }
      }
      this.countOutByCodesApi()
    },
    countOutByCodesApi() {
      if (this.backRepositoryData.smallCodes.size + this.backRepositoryData.midCodes.size + this.backRepositoryData.bigCodes.size === 0) {
        return;
      }
      if (this.backRepositoryData.codeType === '2' && this.backRepositoryData.smallCodes.size + this.backRepositoryData.midCodes.size + this.backRepositoryData.bigCodes.size !== 2) {
        return;
      }

      let mySet = new Set()
      if (this.backRepositoryData.codeType === '2') {
        if (this.backRepositoryData.bigCodes.size === 2) {
          mySet = this.backRepositoryData.bigCodes
        } else if (this.backRepositoryData.midCodes.size === 2) {
          mySet = this.backRepositoryData.midCodes
        } else if (this.backRepositoryData.smallCodes.size === 2) {
          mySet = this.backRepositoryData.smallCodes
        } else {
          return
        }
      }
      let myArray = Array.from(mySet);
      let from = ''
      let to = ''
      if (myArray.length === 2) {
        from = myArray.reduce((min, current) => min < current ? min : current)
        to = myArray.reduce((max, current) => max > current ? max : current)
      }

      const params = {
        "from_number": from,
        "to_number": to,
        "big_number": Array.from(this.backRepositoryData.bigCodes),
        "mid_number": Array.from(this.backRepositoryData.midCodes),
        "small_number": Array.from(this.backRepositoryData.smallCodes),
        "product_number": this.backRepositoryData.form.productNumber,
        "product_id": this.backRepositoryData.form.productId,
      }
      params.out_no = this.backRepositoryData.form.outNo
      params.from_store_id = this.backRepositoryData.form.fromStoreId

      countBackByCodes(params).then((res) => {
        if (res.code == 200) {
          if (this.willIn === res.data) {
            this.$message.error(this.$store.state.code + " 无效")
            this.delCode(this.$store.state.code, matchCode(this.$store.state.code, this.bigLen, this.midLen, this.smallLen))
            return
          }
          this.willIn = res.data
        }
      });
    },
    inRepository() {
      if (this.backRepositoryData.bigCodes.size === 2) {
        this.distanceIn()
      } else {
        this.allIn()
      }
    },
    distanceIn() {
      let mySet
      if (this.backRepositoryData.bigCodes.size === 2) {
        mySet = this.backRepositoryData.bigCodes
      } else if (this.backRepositoryData.midCodes.size === 2) {
        mySet = this.backRepositoryData.midCodes
      } else if (this.backRepositoryData.smallCodes.size === 2) {
        mySet = this.backRepositoryData.smallCodes
      } else {
        this.$message.error("请先扫出两个区间码")
        return
      }
      let myArray = Array.from(mySet);
      // 比较两个元素的大小，将小的值赋值给 from，大的值赋值给 to
      const params = {
        "from_number": myArray.reduce((min, current) => min < current ? min : current),
        "to_number": myArray.reduce((max, current) => max > current ? max : current),
        "product_number": this.backRepositoryData.form.productNumber
      }
      params.product_id = this.backRepositoryData.productId
      params.out_no = this.backRepositoryData.form.outNo
      params.from_store_id = this.backRepositoryData.form.fromStoreId
      this.inRepositoryApi(params);
    },
    allIn() {
      if (this.backRepositoryData.bigCodes.size === 0 && this.backRepositoryData.midCodes.size === 0 && this.backRepositoryData.smallCodes.size === 0) {
        this.$message.error("请先扫码")
        return
      }
      const params = {
        "from_number": "",
        "to_number": "",
        "big_number": Array.from(this.backRepositoryData.bigCodes),
        "mid_number": Array.from(this.backRepositoryData.midCodes),
        "small_number": Array.from(this.backRepositoryData.smallCodes),
        "product_number": this.backRepositoryData.form.productNumber
      }
      params.product_id = this.backRepositoryData.productId
      params.out_no = this.backRepositoryData.form.outNo
      params.from_store_id = this.backRepositoryData.form.fromStoreId
      this.inRepositoryApi(params);
    },
    inRepositoryApi(params) {
      backRepository(params).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.msg)
          this.backRepositoryData = {
            form: {},
            bigCodes: new Set(),
            midCodes: new Set(),
            smallCodes: new Set(),
            codeType: '1',
          },
              this.$forceUpdate()
          this.$store.commit("setbackRepositoryData", this.backRepositoryData)
        }
      });
    }


  },
}
;
</script>
<style scoped>
.marketing {
  margin-top: 50px;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.demonstration {
  display: block;
  color: #8492a6;
  font-size: 14px;
  margin-bottom: 20px;
}

/deep/ .el-input {
  width: 220px;
  font-size: 11px;
}

::v-deep .el-autocomplete-suggestion {
  min-width: 200px;
  width: auto !important;
}

/deep/ .el-table .el-table__cell {
  padding: 1px;
  min-width: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-overflow: ellipsis;
  vertical-align: middle;
  position: relative;
  text-align: left;
}

</style>